const success = (action) => `${action}_SUCCESS`;
const error = (action) => `${action}_ERROR`;

export { success, error };